import { render } from "./EditOrganisation.vue?vue&type=template&id=88347314"
import script from "./EditOrganisation.vue?vue&type=script&lang=js"
export * from "./EditOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__